var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "trash-simple_svg__nc-icon-wrapper",
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "#111",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 16v30H8V16M2 10h44"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M24 22v15M16 22v15M32 22v15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10V2h16v8"
  }))));
}

export default SvgTrashSimple;